import React from "react";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
    const { t } = useTranslation();
    const items = t("faq.items", { returnObjects: true });
    const safeItems = Array.isArray(items) ? items : [];
    return (
        <section id="faq" className="py-16 sm:py-20 lg:py-24 bg-[#FBF7EE]" data-testid="faq-section">
            <div className="max-w-3xl mx-auto px-4 sm:px-6">
                <div className="text-left">
                    <span className="inline-flex items-center gap-2 rounded-full bg-[#F4EBDD] border border-[#E9D9C1] px-3 py-1 text-xs font-semibold text-[#0B4A34] uppercase tracking-wider">{t("faq.eyebrow")}</span>
                    <h2 className="font-display mt-4 text-4xl sm:text-5xl tracking-tight text-[#062A1E]">{t("faq.title")}</h2>
                </div>
                <Accordion type="single" collapsible className="mt-8 rounded-2xl border border-[#E9D9C1] bg-[#FFFDF7] divide-y divide-[#E9D9C1] overflow-hidden" defaultValue="item-0">
                    {safeItems.map((item, idx) => (
                        <AccordionItem key={idx} value={`item-${idx}`} className="border-b-0" data-testid={`faq-item-${idx}`}>
                            <AccordionTrigger className="px-5 sm:px-6 py-4 text-left text-base sm:text-lg font-semibold text-[#062A1E] hover:no-underline">{item.q}</AccordionTrigger>
                            <AccordionContent className="px-5 sm:px-6 pb-5 text-[#1B2621]/80 text-sm sm:text-base leading-relaxed">{item.a}</AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
